<template>
    <div class="module__list">
        <div class="module__list_header">
            <view-actions
                :title="'Modules'"
                :cancel-button-active="false"
                :submit-button-text="'Create module'"
                :submit-button-active="true"
                @emit-submit="createModule"
            />
        </div>
        <div class="module__list_main">
            <component-list
                :empty-state-title="'Modules for this workspace will appear here. Go ahead and create one by clicking Create module.'"
                :filter-search-queryable="true"
                :component-table="ModuleListTable"
                :component-table-name="'modules'"
                :item-name="['module', 'modules']"
                :filter-select-active="true"
                :filter-select-items="filtersSelect"
                :get-pagination-getter="'getEbsModulesPagination'"
                :filter-select-prefix="''"
                :get-items-getter="'getEbsModules'"
                :get-items-dispatch="'ebsModulesGetSCORM'"
                :get-items-dispatch-trigger-name="'get-modules-list'"
                :table-preferences-active="true"
            />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentList from '@/components/default/shared/ComponentList'
import ModuleListTable from '@/components/ebs/modules/list/ModuleListTable'
import { User } from '@/User'

export default {
  name: 'module-list',
  components: { ComponentList, ViewActions },
  computed: {
    filtersSelect () {
      return [
        {
          key: 'labels',
          label: 'Labels',
          type: 'multiselect',
          getItemsGetter: 'getEbsModuleCustomLabelsMappedIdNameStatus',
          getItemsGetterMapped: 'getEbsModuleCustomLabelsMappedLabelValue',
          getItemsDispatch: 'ebsModuleGetLabels',
          getPaginationGetter: 'getEbsModuleCustomLabelsPagination',
          itemName: ['label', 'labels'],
          searchQueryable: true,
          tableLabels: [
            {
              key: 'name',
              title: 'Name',
              type: 'string',
              sortable: true,
              queryable: true
            }
          ]
        },
        {
          key: 'status',
          label: 'Status',
          type: 'checkbox',
          preselected: ['active'],
          values: [
            {
              label: 'Active',
              value: 'active'
            },
            {
              label: 'Archived',
              value: 'deleted'
            }
          ]
        }
      ]
    }
  },
  data () {
    return {
      user: new User(),
      ModuleListTable
    }
  },
  methods: {
    createModule () {
      this.$router.push({ name: 'ebs-module-add' })
    }
  }
}
</script>
